export default {
  namespaced: true,
  state: {
    buttonsDisabled: false,
    pointerEvent: "initial",
    termsAccepted: false,
    reportTermsValidity: false,
  },
  getters: {
    buttonsDisabled: state => state.buttonsDisabled,
    pointerEvent: state => state.pointerEvent,
    termsAccepted: state => state.termsAccepted,
    reportTermsValidity: state => state.reportTermsValidity,
  },
  actions: {
    setButtonsDisabled: (context, disabled) => context.commit("setButtonsState", disabled),
    setPointerEvent: (context, eventName) => context.commit("setPointerEvent", eventName),
    setTermsAccepted: (context, accepted) => context.commit("setTermsAccepted", accepted),
    setReportTermsValidity: (context, valid) => context.commit("setReportTermsValidity", valid),
  },
  mutations: {
    setButtonsState: (state, disabled) => {
      state.buttonsDisabled = disabled;
    },
    setPointerEvent: (state, eventName) => {
      state.pointerEvent = eventName;
    },
    setTermsAccepted: (state, accepted) => {
      state.termsAccepted = accepted;
    },
    setReportTermsValidity: (state, valid) => {
      state.reportTermsValidity = valid;
    },
  },
};
